import fileDuplicatesModalView from './fileDuplicatesModalComponent.html';
import './fileDuplicatesModalComponent.css';

export function fileDuplicatesModalComponent() {
	return {
		bindings: {
			open: '<?',
			filesWithDuplicates: '<?',
			uploadDuplicate: '&',
			cancelUpload: '&',
			uploaderPercent: '=',
		},
		controllerAs: 'vm',
		controller: fileDuplicatesModalComponentCtrl,
		template: fileDuplicatesModalView,
	};
}

export class fileDuplicatesModalComponentCtrl {
	constructor() {
		'ngInject';
	}

	async continueUploadingDuplicate(index, file) {
		this.uploaderPercent = 1;
		this.uploadDuplicate && (await this.uploadDuplicate({ $index: index, $file: file }));
		this.uploaderPercent = 100;
	}

	doNotUploadDuplicate(index, file) {
		this.cancelUpload && this.cancelUpload({ $index: index, $file: file });
	}
}
